import { USER_LANGUAGE_URL } from 'constants/config';
import { fetchJson as fetch } from 'utils/fetchJson/fetchJson';

const userLanguage = {
  update: (senderEmail, locale) => {
    const payload = {
      user: {
        email: senderEmail,
        language: locale,
      },
    };
    const body = JSON.stringify(payload);
    const options = { body, method: 'PUT' };

    return fetch(USER_LANGUAGE_URL, options);
  },
};

export { userLanguage };
